import React from 'react';

import type { DocNode } from '@atlaskit/adf-schema/doc';
import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import { JIRATransformer } from '@atlaskit/editor-jira-transformer';
import { JSONTransformer } from '@atlaskit/editor-json-transformer/JSONTransformer-2';
import { Box } from '@atlaskit/primitives/compiled/box';
import ReactRenderer from '@atlaskit/renderer/renderer';

import type { HtmlRendererProps } from './types';

export const HtmlRenderer = ({ fieldId, htmlContent }: HtmlRendererProps): React.JSX.Element => {
	try {
		const jiraTransformer = new JIRATransformer(defaultSchema);
		const adfTransformer = new JSONTransformer();
		const pmNode = jiraTransformer.parse(htmlContent);
		const adf = adfTransformer.encode(pmNode) as DocNode;

		return <ReactRenderer key={fieldId} document={adf} />;
	} catch (err) {
		// TODO: REQIN-1562 - Add error handling / logging
		return <Box testId={`proforma-html-renderer-error-${fieldId}`} />;
	}
};
